type Brand<T, B extends string> = T & { readonly __brand: B };

export type EventId = Brand<string, 'EventId'>;
export type SeriesId = Brand<string, 'SeriesId'>;
export type RequestId = Brand<string, 'RequestId'>;
export type BuildingId = Brand<string, 'BuildingId'>;
export type SpaceId = Brand<string, 'SpaceId'>;
export type RegionId = Brand<string, 'RegionId'>;
export type PlannerAccessId = Brand<string, 'PlannerAccessId'>;

export const asEventId = (s: string): EventId => s as EventId;
export const asSeriesId = (s: string): SeriesId => s as SeriesId;
export const asRequestId = (s: string): RequestId => s as RequestId;
export const asBuildingId = (s: string): BuildingId => s as BuildingId;
export const asSpaceId = (s: string): SpaceId => s as SpaceId;
export const asRegionId = (s: string): RegionId => s as RegionId;
export const asPlannerAccessId = (s: string): PlannerAccessId => s as PlannerAccessId;
